"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import CourseSection from "../course-section";
import CourseSwiperNav from "../course-swiper-nav";
import CourseTeacher from "./course-teacher";

function CourseTeachers({ teachers }) {
  const prevNavRef = React.useRef(null);
  const nextNavRef = React.useRef(null);

  const [swiper, setSwiper] = React.useState(teachers);

  return (
    <CourseSection
      id="meet-our-teachers"
      title="Meet Our Teachers"
      action={
        <CourseSwiperNav
          swiper={swiper}
          prevNavRef={prevNavRef}
          nextNavRef={nextNavRef}
        />
      }
    >
      <Swiper
        modules={[Navigation]}
        slidesPerView={1.6}
        spaceBetween={16}
        slidesOffsetAfter={16}
        onSwiper={setSwiper}
        breakpoints={{
          600: {
            slidesPerView: 2,
            slidesOffsetAfter: 0,
          },
        }}
        className="-mr-4 lg:mr-0"
      >
        {teachers.map((teacher) => (
          <SwiperSlide key={teacher.id}>
            <CourseTeacher teacher={teacher} />
          </SwiperSlide>
        ))}
      </Swiper>
    </CourseSection>
  );
}

export default CourseTeachers;
